import Main from '@/views/main/Index'
import { authRoute } from '../guards/auth'

import os from './os'
import osTests from './osTests'
import os_sw from './os-sw'
import osFinished from './os-finished'
import extract from './extract'
import activesmovementbatch from './activesmovementbatch'
import send_commands from './sendcommand'
import schedule from './schedule'

import settings from './settings/settings'
import sync from './sync/sync'

import users from './settings/users/users'
import company from './settings/users/company'
import groups from './settings/users/groups'
import systemModules from './settings/users/systemModules'
import permission from './settings/users/permission'

import garageaccredited from './settings/test-registers/garageaccredited'
import bankaccount from './settings/test-registers/bankaccount'
import maintancereason from './settings/test-registers/maintancereason'
import acessories from './settings/test-registers/acessories'
import vehiclebrands from './settings/test-registers/vehicleBrands'
import banks from './settings/test-registers/banks'
import causeofmaintance from './settings/test-registers/causeofmaintance'
import shippingMethodTransportation from './settings/test-registers/shippingmethodtransportation'
import shippingDestinyTransportation from './settings/test-registers/shippingdestinytransportation'

import activestype from './settings/stock-registers/activestype'
import manufacturer from './settings/stock-registers/manufacturer'
import active from './settings/stock-registers/active'
import model from './settings/stock-registers/model'
import activeStatus from './settings/stock-registers/activeStatus'
import status from './settings/stock-registers/status'
import movementType from './settings/stock-registers/movementType'
import editequipment from './settings/stock-registers/editequipment'
import activestatusdefault from './settings/stock-registers/activestatusdefault'
import component from './settings/stock-registers/component'
import alerts from './settings/stock-registers/alerts'

import commandtypes from './settings/parameters/commandTypes'
import servicetypes from './settings/parameters/serviceTypes'
import positions_offset from './settings/parameters/positionsandoffset'
import offset_plate from './settings/parameters/offsetbyplate'
import arena_vehicles_2001 from './settings/parameters/arenavehicles2001'

import reports from './reports/index'
import report_activemovement from './reports/activemovement'
import report_lastpositions from './reports/lastpositions'
import report_comission from './reports/comissions'
import report_roteirization from './reports/roteirizations'
import report_devicelogs from './reports/devicelogs'
import report_drivebehavior from './reports/drivebehavior'
import amount_by_client from './reports/service/amountbyclient'
import report_trackers from './reports/trackers'
import report_stock_inventory from './reports/stockinventory'
import costMaterialTransportation from './reports/costmaterialtransportation'
import report_temperature_sensor_delay from './reports/sensortemperaturedelay'
import report_rfid_reader_delay from './reports/rfidreaderdelay'

import search_vehicle from './settings/consults/searchvehicle'
import iccid from './settings/consults/iccid'
import os_logs from './settings/consults/oslogs'
import checklist from './settings/consults/checklist'

import remoteid from './settings/app-frotix-registers/remoteid'
import arenaevents from './settings/app-frotix-registers/arenaevents'
import enginegeocode from './settings/app-frotix-registers/enginegeocode'
import userWebService from './settings/app-frotix-registers/userwebservice'

import financialVehicle from './settings/financial/vehicle'
import financialContract from './settings/financial/contract'

import arenaEquipment from './settings/arena/equipment'
import arenaEquipmentVersion from './settings/arena/equipmentversion'
import arenaVehicleType from './settings/arena/vehicletype'
import arenaPointType from './settings/arena/pointtype'
import arenaUser from './settings/arena/user'
import linkVehicleAndAreaGenerateEvents from './settings/arena/linkvehicleandareagenerateevents'
import cleanPosition from './settings/arena/cleanposition'
import cleanTriggeredEvents from './settings/arena/cleantriggeredevent'
import veiOffTemp from './settings/arena/veiofftemp'

import frotaDriver from './settings/frota/driver'
import frotaHelper from './settings/frota/helper'
import infractionTypes from './settings/frota/infractions-types'

import roteirization from './settings/integrador/roteirization'
import integrator from './settings/integrador/integrator'
import customDeliveryDetails from './settings/integrador/custom-delivery-details'
import integratorInstallInstructions from './settings/integrador/install-instructions'

import frotix_management from './frotixmanagement/index'
import frotix_management_vehicle_evolution from './frotixmanagement/vehicleevolution'

import signature from './settings/atendimentos/signature'
import tire from './settings/atendimentos/tire'

export default {
  path: '/main',
  component: Main,
  meta: {
    breadcrumb: 'Home',
    icon: 'fa-home'
  },
  async beforeEnter (to, from, next) {
    const canEnter = await authRoute()
    if (canEnter) {
      return next(true)
    }
    next('')
  },
  children: [
    {
      path: '',
      name: 'main',
      meta: {
        name: 'Home'
      },
      component: () => import(/* webpackChunkName: "main-home" */ '@/views/main/Home.vue')
    },
    ...users,
    ...company,
    ...groups,
    ...systemModules,
    ...permission,
    ...settings,
    ...garageaccredited,
    ...bankaccount,
    ...maintancereason,
    ...activestype,
    ...manufacturer,
    ...active,
    ...model,
    ...os,
    ...osTests,
    ...extract,
    ...vehiclebrands,
    ...commandtypes,
    ...servicetypes,
    ...banks,
    ...activesmovementbatch,
    ...reports,
    ...report_activemovement,
    ...activeStatus,
    ...status,
    ...movementType,
    ...editequipment,
    ...report_lastpositions,
    ...activestatusdefault,
    ...component,
    ...report_comission,
    ...positions_offset,
    ...offset_plate,
    ...search_vehicle,
    ...report_trackers,
    ...arena_vehicles_2001,
    ...report_stock_inventory,
    ...send_commands,
    ...alerts,
    ...schedule,
    ...iccid,
    ...os_logs,
    ...roteirization,
    ...os_sw,
    ...checklist,
    ...signature,
    ...tire,
    ...report_roteirization,
    ...report_devicelogs,
    ...report_drivebehavior,
    ...amount_by_client,
    ...remoteid,
    ...arenaevents,
    ...enginegeocode,
    ...causeofmaintance,
    ...osFinished,
    ...acessories,
    ...financialVehicle,
    ...financialContract,
    ...arenaEquipment,
    ...arenaEquipmentVersion,
    ...arenaVehicleType,
    ...arenaPointType,
    ...arenaUser,
    ...linkVehicleAndAreaGenerateEvents,
    ...cleanPosition,
    ...cleanTriggeredEvents,
    ...frotaDriver,
    ...frotaHelper,
    ...integrator,
    ...customDeliveryDetails,
    ...veiOffTemp,
    ...userWebService,
    ...costMaterialTransportation,
    ...shippingMethodTransportation,
    ...shippingDestinyTransportation,
    ...sync,
    ...frotix_management,
    ...frotix_management_vehicle_evolution,
    ...report_temperature_sensor_delay,
    ...report_rfid_reader_delay,
    ...integratorInstallInstructions,
    ...infractionTypes
  ]
}
